/**
 * MY chatflow plug-in 등록 entry-point.
 *   App 부팅 시 한 번 import 되어 side-effect 로 chatflow 들을 shared registry 에 등록.
 *
 * 등록 위치 — `frontend/src/main.ts` (또는 startTask 진입 시점) 에서:
 *   import '@/features/startTask/preset_task/my/preset/chatflows';
 */

import { registerChatFlow } from '../../../shared/preset/chatflows/chatFlowRegistry';
import { incorporationFlow } from './incorporationFlow';
import { incorporationPostFlow } from './incorporationPostFlow';
import { incorporationDocFlow } from './incorporationDocFlow';
import { nameReservationFlow } from './nameReservationFlow';
import { changeAddressFlow } from './changeAddressFlow';
import { changeBusinessAddressFlow } from './changeBusinessAddressFlow';
import { updateBusinessAddressFlow } from './updateBusinessAddressFlow';
import { agmFlow } from './agmFlow';
import { changeOfficerFlow } from './changeOfficerFlow';
import { annualReturnFlow } from './annualReturnFlow';
import { allotmentSharesFlow } from './allotmentSharesFlow';
import { allotmentOtcFlow } from './allotmentOtcFlow';
import { bonusIssueFlow } from './bonusIssueFlow';
import { boNoticesFlow } from './boNoticesFlow';
import { boAppendixFlow } from './boAppendixFlow';
import { declarationNonBoFlow } from './declarationNonBoFlow';
import { extensionOfTimeFlow } from './extensionOfTimeFlow';
import { exemptPrivateCompanyFlow } from './exemptPrivateCompanyFlow';
import { shareCertificateFlow } from './shareCertificateFlow';
import { transferSharesFlow } from './transferSharesFlow';
import { cddFlow } from './cddFlow';
import { eddFlow } from './eddFlow';
import { directorResignationFlow } from './directorResignationFlow';
import { secretaryResignationFlow } from './secretaryResignationFlow';

// ⚠️ 등록 순서 — chatFlowRegistry 가 첫 매치 win 방식이므로 더 구체적인 flow 가 먼저 와야 한다.
//   incorporationDocFlow  = M32014 / M32104 (Incorporation DOC Studio)
//   incorporationPostFlow = M32101 / incorporation(post)
//   incorporationFlow     = category incorporation (fallback)
// nameReservationFlow = M32001 (Name Reservation — 문서 없음, 바로 e-Filing).
//   INCORPORATION 카테고리에 들어 있어 incorporationFlow(카테고리 fallback)와 같은 자리에 있지만,
//   registry 가 TASK_CODE 를 먼저 보므로 M32001 은 이 flow 로 확정된다. 그래도 먼저 등록해 둔다.
registerChatFlow(nameReservationFlow);
registerChatFlow(incorporationDocFlow);
registerChatFlow(incorporationPostFlow);
registerChatFlow(incorporationFlow);
// M32017 (Change Business Address, Section 47(3)) — task-code 매칭. category 'change address' 로도
//   changeAddressFlow(M32102) 에 걸릴 수 있어 더 구체적인 이 flow 를 먼저 등록(첫 매치 win).
registerChatFlow(changeBusinessAddressFlow);
// M32018 (Update Business Address, Section 47(2)) — task-code 매칭. 더 구체적이므로 먼저 등록.
registerChatFlow(updateBusinessAddressFlow);
registerChatFlow(changeAddressFlow);
registerChatFlow(agmFlow);
registerChatFlow(changeOfficerFlow);
registerChatFlow(annualReturnFlow);
registerChatFlow(allotmentOtcFlow);
registerChatFlow(bonusIssueFlow);
registerChatFlow(boNoticesFlow);
registerChatFlow(boAppendixFlow);
registerChatFlow(declarationNonBoFlow);
registerChatFlow(extensionOfTimeFlow);
registerChatFlow(exemptPrivateCompanyFlow);
registerChatFlow(shareCertificateFlow);
registerChatFlow(allotmentSharesFlow);
registerChatFlow(transferSharesFlow);
registerChatFlow(cddFlow);
registerChatFlow(eddFlow);
registerChatFlow(directorResignationFlow);
registerChatFlow(secretaryResignationFlow);
